
<div style="text-align: center">
    <c-customer-select
        :label  = "$t('unit.bulkupdate.customer.select')"
        v-model = "customer"
        hide-details
    />
    <v-btn
        :disabled = "!customer"
        color     = "primary"
        class     = "dialog-button mt-8"
        @click    = "onUpdate"
        rounded
    >
        {{ $t('unit.bulkupdate.command') }}
    </v-btn>
</div>
